import {
  Component,
  OnInit
} from '@angular/core';

import { SkyModalInstance } from '../modal';
import { SkyResources } from '../resources';

import {
  SkyConfirmCloseEventArgs,
  SkyConfirmType,
  SkyConfirmButton,
  SkyConfirmButtonConfig
} from './types';

import {
  SkyConfirmModalContext
} from './confirm-modal-context';


export class SkyConfirmComponent implements OnInit {
  public buttons: SkyConfirmButton[];
  public message: string;

  constructor(
    private config: SkyConfirmModalContext,
    private modal: SkyModalInstance
  ) { }

  public ngOnInit() {
    let buttons;

    if (this.config.type === SkyConfirmType.Custom && this.config.buttons.length > 0) {
      buttons = this.getCustomButtons(this.config.buttons);
    } else {
      buttons = this.getPresetButtons();
    }

    this.buttons = buttons;
    this.message = this.config.message;
  }

  public close(button: SkyConfirmButton) {
    const result: SkyConfirmCloseEventArgs = {
      action: button.action
    };

    this.modal.close(result);
  }

  private getPresetButtons(): SkyConfirmButton[] {
    let buttons: SkyConfirmButton[];

    switch (this.config.type) {
      default:
      case SkyConfirmType.OK:
        buttons = [
          {
            text: SkyResources.getString('confirm_dialog_default_ok_text'),
            autofocus: true,
            styleType: 'primary',
            action: 'ok'
          }
        ];
        break;

      case SkyConfirmType.YesNoCancel:
        buttons = [
          {
            text: SkyResources.getString('confirm_dialog_default_yes_text'),
            autofocus: true,
            styleType: 'primary',
            action: 'yes'
          },
          {
            text: SkyResources.getString('confirm_dialog_default_no_text'),
            styleType: 'default',
            action: 'no'
          },
          {
            text: SkyResources.getString('confirm_dialog_default_cancel_text'),
            styleType: 'link',
            action: 'cancel'
          }
        ];
        break;

      case SkyConfirmType.YesCancel:
        buttons = [
          {
            text: SkyResources.getString('confirm_dialog_default_yes_text'),
            autofocus: true,
            styleType: 'primary',
            action: 'yes'
          },
          {
            text: SkyResources.getString('confirm_dialog_default_cancel_text'),
            styleType: 'link',
            action: 'cancel'
          }
        ];
        break;
    }

    return buttons;
  }

  private getCustomButtons(buttonConfig: SkyConfirmButtonConfig[]): SkyConfirmButton[] {
    const buttons: SkyConfirmButton[] = [];

    buttonConfig.forEach((config: SkyConfirmButtonConfig) => {
      buttons.push({
        text: config.text,
        action: config.action,
        styleType: config.styleType || 'default',
        autofocus: config.autofocus || false
      } as SkyConfirmButton);
    });

    return buttons;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-confirm',
  template: `<div class="sky-confirm">
  <sky-modal>
    <sky-modal-content>
      <div class="sky-confirm-message">
        {{ message }}
      </div>
      <div class="sky-confirm-buttons">
        <button
          *ngFor="let button of buttons"
          type="button"
          class="sky-btn"
          ngClass="sky-btn-{{ button.styleType }}"
          (click)="close(button)"
          [attr.autofocus]="button.autofocus ? 'autofocus': null">
          {{ button.text }}
        </button>
      </div>
    </sky-modal-content>
  </sky-modal>
</div>
`,
  styles: [`.sky-confirm-message {
  font-family: "Blackbaud Sans", "Helvetica Neue", Arial, sans-serif;
  color: #282b31;
  font-weight: 600;
  font-size: 16px;
  margin-top: 5px;
  margin-bottom: 20px;
}

.sky-confirm-buttons .sky-btn {
  margin-right: 5px;
}

.sky-confirm-buttons .sky-btn:last-child {
  margin-right: 0;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyConfirmModalContext, },
{type: SkyModalInstance, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
